import { ProductType } from "@thenounproject/lingo-core";

import createEntityReducer from "../helpers/createEntityReducer";
import { getEntitiesFromAction, mergeEntitiesIfChanged } from "../helpers/mergeIfChanged";
import { applyProductTypeTemplate } from "@actions/productTypes/useApplyProductTypeTemplate";
import { createProductType } from "@actions/productTypes/useCreateProductType";
import { updateProductType } from "@actions/productTypes/useUpdateProductType";
import { deleteProductType } from "@actions/productTypes/useDeleteProductType";
import { fetchProductTypes } from "@actions/productTypes/useProductTypes";
import { invalidateQuery } from "@actions/actionCreators/createQueryAction";

const invalidateProductTypes = (
  state: Parameters<typeof fetchProductTypes.getQueryData>[0],
  spaceId: number
) => {
  fetchProductTypes.getQueryData(state, { spaceId }).forEach(q => invalidateQuery(q));
};

export default createEntityReducer<ProductType>(
  "productTypes",
  builder => {
    builder
      .addCase(applyProductTypeTemplate.fulfilled, (state, action) => {
        invalidateProductTypes(state, action.meta.arg.spaceId);
      })
      .addCase(createProductType.fulfilled, (state, action) => {
        invalidateProductTypes(state, action.meta.arg.spaceId);
      })
      .addCase(updateProductType.fulfilled, (state, action) => {
        invalidateProductTypes(state, action.meta.arg.spaceId);
      })
      .addCase(deleteProductType.fulfilled, (state, action) => {
        invalidateProductTypes(state, action.meta.arg.spaceId);
      });
  },
  objectBuilder => {
    objectBuilder.addDefaultCase((state, action) => {
      const productTypes = getEntitiesFromAction<ProductType>(action, "productTypes");
      return mergeEntitiesIfChanged(
        state,
        productTypes,
        (objValue: unknown, srcValue: unknown, key: string) => {
          // Replace `fields` wholesale rather than letting lodash merge arrays by index,
          // which would leave deleted fields in place.
          if (key === "fields") return srcValue ?? objValue;
          return undefined;
        }
      );
    });
  }
);
